// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "  .qualifybuttons_button {\r\n    background: #f05a25 !important;\r\n    font-size: 1.2vw !important;\r\n    font-family: \"Antonio-Regular\" !important;\r\n    height: 7vh;\r\n    margin-top: 2vw !important;\r\n    width: 18vw;\r\n  }\r\n  .qualifybuttons_buttons {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    padding-bottom: 30px;\r\n    justify-content: space-around;\r\n}\r\n  ", ""]);
// Exports
module.exports = exports;
